import PageCommon from "../PageCommon.js";
import Pqp from "../../3x1010/Pqp.js";
import Globals from "../../Globals.js";

export default class PageSolrFullText extends PageCommon {
  constructor() {
    super();
  }
  init($data) {
    super.init($data);
    this.showPreloader(false);
    Pqp.trace("PageSolrFullText - Hello world");

    // dispaccio un evento globale
    try {
      this.dispatchInitEvent(TheDisp.EV_PAGETHIS_INITED);
    } catch (error) {
      // console.log(error);
    }
    // solr
    this.collectionName = "FOTOTECA_coll";
    this.lastRq = null;
    $(".wlfInfo").text(this.collectionName);
    $(".wlfSearch").on("click", this.onSearch.bind(this, false));
    $("body").keydown(this.onSearch.bind(this, true));
    $(".wlfPrev").on("click", this.onMove.bind(this, -1));
    $(".wlfNext").on("click", this.onMove.bind(this, +1));
  }

  get isHomepage() {
    return true;
  }

  onMove(dir) {
    if (this.lastRq == null) return;
    //
    var pageSize = this.lastRq.options.RowsNum;
    var maxStart = Math.max(0, Math.ceil(this.lastRq.TotalRows / pageSize) - 1) * pageSize;
    var rqStart = this.lastRq.options.RowStart + dir * pageSize;

    if (rqStart < 0 || rqStart > maxStart) return;
    //
    this.lastRq.options.RowStart = rqStart;
    var rq = this.lastRq;
    //
    this.showPreloader(true);
    console.log(rq);
    thatServiceManeger.standardCall("/api/solr/" + rq.action, rq, this.onCallHandler.bind(this));
  }

  onSearch(key, e) {
    //e.preventDefault();
    if (key) {
      if (!(e.which == 13)) return;
    }
    var $search = $(".wlfInputText").val();
    // console.log("onSearch", $search);
    //this.search($search);
    var rq = {
      action: "fulltext",
      collectionName: this.collectionName,
      query: {
        Value: $search,
        Compare: $(".wlfMode").val(),
        Occurency: $(".wlfNot").prop("checked") ? "NOT" : "MUST",
      },
      options: {
        IncludeChilds: true,
        IncludeRelations: 1,
        FilterRelations: null,
        RowStart: 0,
        RowsNum: 100,
        OrderBy: "id desc",
        Fields: "*",
        //
        DeepSearch: true,
      },
    };
    this.lastRq = rq;
    this.showPreloader(true);
    console.log(rq);
    thatServiceManeger.standardCall("/api/solr/" + rq.action, rq, this.onCallHandler.bind(this));
  }

  onCallHandler(rs) {
    this.showPreloader(false);
    if (!rs.Success) {
      this.lastRq = null;
      //
      $(".wlfTotalRows").text();
      $(".wlfPageSize").text();
      $(".wlfPageRows").text();
      $(".wlfRowStart").text();
      $(".wlfRows").text("");
      //
      alert("Error");
      return;
    }
    // mi setto il total rows nella request (per il paging)
    this.lastRq.TotalRows = rs.TotalRows;
    //
    $(".wlfTotalRows").text(rs.TotalRows);
    $(".wlfPageSize").text(this.lastRq.options.RowsNum);
    $(".wlfPageRows").text(rs.Rows.length);
    $(".wlfRowStart").text(rs.RowStart);
    $(".wlfRows").text("");
    //
    var i = 0;
    for (var o of rs.Rows) {
      //var row = $("<texarea cols='300' rows='10' style='background-color:"+(i%2==0 ? "#EEEEEE" : "#FFFFFF")+"'></texarea>");
      var row = $("<span  style='background-color:" + (i % 2 == 0 ? "#EEEEEE" : "#FFFFFF") + "'></span>");
      var text = JSON.stringify(o /*, null, 2*/);
      row.text(rs.RowStart + i + "\t" + text);
      $(".wlfRows").append(row);
      $(".wlfRows").append("<br>");
      i++;
    }
  }
}
